/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var notSupport = new Error('The client is not supported');

var CLIENT_FLAGS = {
  IS_DOCS_KDESKTOP_WIN_CLIENT: 'isDocsKdesktopWinClient',
  // 金山文档PC/MAC客户端
  IS_DOCS_KDESKTOP_MAC_CLIENT: 'isDocsKdesktopMacClient',
  // 金山文档PC/MAC客户端
  IS_DOCS_WXMINIPROGRAM_CLIENT: 'isDocsWxminiprogramClient',
  // 微信小程序
  IS_DOCS_QQMINIPROGRAM_CLIENT: 'isDocsQqminiprogramClient',
  // QQ小程序
  IS_DOCS_PC_WXMINIPROGRAM_CLIENT: 'isDocsPcWxminiprogramClient',
  // 金山文档 PC 微信小程序
  IS_DOCS_IPAD_CLIENT: 'isDocsIpadClient',
  // 金山文档IPAD
  IS_DOCS_AN_PAD_CLIENT: 'isDocsAnPadClient',
  // 金山文档AnPad
  IS_DOCS_IOS_CLIENT: 'isDocsIosClient',
  // 金山文档IOS
  IS_DOCS_AN_CLIENT: 'isDocsAnClient',
  // 金山文档IPAD
  IS_WPS_WIN_CLIENT: 'isWpsWinClient',
  // WPS客户端
  IS_WPS_MAC_CLIENT: 'isWpsMacClient',
  // WPS客户端
  IS_WPS_LINUX_CLIENT: 'isWpsLinuxClient',
  // linux客户端
  IS_WPS_IOS_CLIENT: 'isWpsIosClient',
  // WPS ios客户端
  IS_WPS_AN_CLIENT: 'isWpsAnClient',
  // WPS 安卓客户端
  IS_WPS_IPAD_CLIENT: 'isWpsIpadClient',
  // WPS ios客户端
  IS_WPS_AN_PAD_CLIENT: 'isWpsAnPadClient',
  // WPS 安卓客户端
  IS_BROWSER_CLIENT: 'isBrowserClient',
  // 浏览器
  IS_WOA_IOS_CLIENT: 'isWoaIosClient',
  // woa（金山协作） IOS 客户端
  IS_WOA_AN_CLIENT: 'isWoaAnClient',
  // woa（金山协作） 安卓 客户端
  IS_WOA_MAC_CLIENT: 'isWoaMacClient',
  // woa（金山协作） MAC 客户端
  IS_WOA_WIN_CLIENT: 'isWoaWinClient',
  // woa（金山协作） window 客户端
  IS_WOA_LINUX_CLIENT: 'isWoaLinuxClient',
  // woa（金山协作） LINUX 客户端
  IS_WOA_IPAD_CLIENT: 'isWoaIpadClient',
  // woa（金山协作） Ipad 客户端
  IS_WOA_AN_PAD_CLIENT: 'isWoaAnPadClient' // woa（金山协作） 安卓pad 客户端

};

var getCookie = function getCookie(name) {
  var _document$cookie$matc;

  return (_document$cookie$matc = document.cookie.match("[;s+]?".concat(name, "=([^;]*)"))) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop();
}; // 获取WPS客户端


var getWPSClientStatus = function getWPSClientStatus() {
  return typeof window['cefQuery'] !== 'undefined' || typeof window['wpsQuery'] !== 'undefined';
}; // 金山文档的PC客户端


var getDocsKdesktopClientStatus = function getDocsKdesktopClientStatus(userAgent) {
  var result = /kdesktop\/\d+\.\d+/ig.test(userAgent);
  return result;
}; // 金山文档的微信小程序


var getDocsWxClientStatus = function getDocsWxClientStatus(userAgent) {
  var isQQ = / QQ/i.test(userAgent);
  var result = userAgent.toLowerCase().indexOf('miniprogram') >= 0 && !isQQ;
  return result;
}; // 金山文档的qq小程序


var getDocsQqClientStatus = function getDocsQqClientStatus(userAgent) {
  var isQQ = / QQ/i.test(userAgent);
  var result = userAgent.toLowerCase().indexOf('miniprogram') >= 0 && isQQ;
  return result;
}; // 金山文档的Ios


var getDocsIosClientStatus = function getDocsIosClientStatus(userAgent) {
  var isMobile = /m-kdocs\/\d+\.\d+/ig.test(userAgent);
  var result = isMobile && /device_model\/iPhone/ig.test(userAgent);
  return result;
}; // 金山文档的Ipad


var getDocsIpadClientStatus = function getDocsIpadClientStatus(userAgent) {
  var isMobile = /m-kdocs\/\d+\.\d+/ig.test(userAgent);
  var result = isMobile && /device_model\/iPad/ig.test(userAgent);
  return result;
}; // 金山文档的安卓


var getDocsAnClientStatus = function getDocsAnClientStatus(userAgent) {
  var isMobile = /m-kdocs\/\d+\.\d+/ig.test(userAgent);
  var result = isMobile && /device_model\/androidPhone/ig.test(userAgent);
  return result;
}; // 金山文档的金山文档安卓Pad


var getDocsAnIpadClientStatus = function getDocsAnIpadClientStatus(userAgent) {
  var isMobile = /m-kdocs\/\d+\.\d+/ig.test(userAgent);
  var result = isMobile && /device_model\/androidPad/ig.test(userAgent);
  return result;
};

var getWinStatus = function getWinStatus(userAgent) {
  var flagList = ['win32', 'win64', 'wow32', 'wow64', 'windows']; // 增加windows 兼容win7下wps缺少其他标识场景

  var isWin = flagList.some(function (item) {
    return userAgent.toLowerCase().indexOf(item) >= 0;
  });
  return isWin;
};

var getMacStatus = function getMacStatus(userAgent) {
  var isMac = /macintosh|mac os x/i.test(userAgent.toLowerCase());
  return isMac;
};

var getLinuxStatus = function getLinuxStatus(userAgent) {
  var isLinux = /linux/i.test(userAgent.toLowerCase());
  return isLinux;
}; // wps 安卓移动端


var getWPSAnClientStatus = function getWPSAnClientStatus() {
  var wpsua = getCookie('wpsua') || '';
  var info = atob(wpsua);
  return info.indexOf('android-office') >= 0 && info.indexOf('android-pad') < 0;
};

var getWPSAnPadClientStatus = function getWPSAnPadClientStatus() {
  var wpsua = getCookie('wpsua') || '';
  var info = atob(wpsua);
  return info.indexOf('android-office') >= 0 && info.indexOf('android-pad') >= 0;
}; // wps Ios


var getWPSIosClientStatus = function getWPSIosClientStatus(userAgent) {
  var _window, _window$webkit, _window$webkit$messag;

  return userAgent.toLowerCase().indexOf('wpsios') >= 0 || !!((_window = window) !== null && _window !== void 0 && (_window$webkit = _window.webkit) !== null && _window$webkit !== void 0 && (_window$webkit$messag = _window$webkit.messageHandlers) !== null && _window$webkit$messag !== void 0 && _window$webkit$messag.handleReq);
};

var getWPSIPadClientStatus = function getWPSIPadClientStatus(_ref) {
  var _window2, _window2$webkit, _window2$webkit$messa;

  var userAgent = _ref.userAgent,
      platform = _ref.platform,
      maxTouchPoints = _ref.maxTouchPoints;
  var isMkdocs = /m-kdocs\/\d+\.\d+/ig.test(userAgent);
  return !isMkdocs && platform === 'MacIntel' && maxTouchPoints > 1 && !!((_window2 = window) !== null && _window2 !== void 0 && (_window2$webkit = _window2.webkit) !== null && _window2$webkit !== void 0 && (_window2$webkit$messa = _window2$webkit.messageHandlers) !== null && _window2$webkit$messa !== void 0 && _window2$webkit$messa.handleReq);
}; // woa pc 客户端


var getWoaPcClientStatus = function getWoaPcClientStatus(userAgent) {
  var regex = /xiezuo\/\d+\.\d+\.\d+/; // 匹配 xiezuo/ 之后的数字和点（如：5.4.1）

  var result = regex.test(userAgent);
  return result;
}; // woa IOS 客户端


var getWoaIosClientStatus = function getWoaIosClientStatus(userAgent) {
  var regex = /ios-woa\/\d+\.\d+\.\d+/; // 匹配 ios/ 之后的数字和点（如：5.4.1）

  var result = regex.test(userAgent);
  return result;
}; // woa IOS 客户端


var getWoaAnClientStatus = function getWoaAnClientStatus(userAgent) {
  var regex = /android-woa\/\d+\.\d+\.\d+/; // 匹配 android/ 之后的数字和点（如：5.4.1）

  var result = regex.test(userAgent);
  return result;
}; // woa 安卓pad 客户端


var getWoaAnPadClientStatus = function getWoaAnPadClientStatus(userAgent) {
  var regex = /android-woa.*appIsTablet|appIsTablet.*android-woa/; // 匹配 android-woa+appIsTablet

  var result = regex.test(userAgent);
  return result;
}; // woa ipad 客户端


var getWoaIpadClientStatus = function getWoaIpadClientStatus(userAgent) {
  var regex = /iPad.*ios-woa\/\d+\.\d+\.\d+|ios-woa\/\d+\.\d+\.\d+.*iPad/; // 匹配 iPad + ios-woa/xx.xx.xx

  var result = regex.test(userAgent);
  return result;
}; // PC 微信小程序 客户端


var getPcWxminiprogramClientStatus = function getPcWxminiprogramClientStatus(userAgent) {
  var result = /miniprogramenv\/(windows|mac)/i.test(userAgent);
  return result;
};
/**
 * 获取当前客户端
 */


var index_cjs = {
  CLIENT_FLAGS: CLIENT_FLAGS,
  getCurrentClient: function getCurrentClient() {
    var _ref2 = navigator || {},
        userAgent = _ref2.userAgent,
        platform = _ref2.platform,
        maxTouchPoints = _ref2.maxTouchPoints;

    if (getPcWxminiprogramClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT;
    }

    if (getWoaIpadClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_IPAD_CLIENT;
    }

    if (getWoaAnPadClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_AN_PAD_CLIENT;
    }

    if (getWoaPcClientStatus(userAgent) && getWinStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_WIN_CLIENT;
    }

    if (getWoaPcClientStatus(userAgent) && getMacStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_MAC_CLIENT;
    }

    if (getWoaPcClientStatus(userAgent) && getLinuxStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_LINUX_CLIENT;
    }

    if (getWoaIosClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_IOS_CLIENT;
    }

    if (getWoaAnClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WOA_AN_CLIENT;
    }

    if (getWPSClientStatus() && getWinStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WPS_WIN_CLIENT;
    }

    if (getWPSClientStatus() && getMacStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WPS_MAC_CLIENT;
    }

    if (getWPSClientStatus() && getLinuxStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WPS_LINUX_CLIENT;
    }

    if (getDocsKdesktopClientStatus(userAgent) && getWinStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT;
    }

    if (getDocsKdesktopClientStatus(userAgent) && getMacStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT;
    }

    if (getDocsWxClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT;
    }

    if (getDocsQqClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_QQMINIPROGRAM_CLIENT;
    }

    if (getDocsIpadClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT;
    }

    if (getDocsIosClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_IOS_CLIENT;
    }

    if (getDocsAnIpadClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT;
    }

    if (getDocsAnClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_DOCS_AN_CLIENT;
    }

    if (getWPSIPadClientStatus({
      userAgent: userAgent,
      platform: platform,
      maxTouchPoints: maxTouchPoints
    })) {
      return CLIENT_FLAGS.IS_WPS_IPAD_CLIENT;
    }

    if (getWPSIosClientStatus(userAgent)) {
      return CLIENT_FLAGS.IS_WPS_IOS_CLIENT;
    }

    if (getWPSAnClientStatus()) {
      return CLIENT_FLAGS.IS_WPS_AN_CLIENT;
    }

    if (getWPSAnPadClientStatus()) {
      return CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT;
    }

    return CLIENT_FLAGS.IS_BROWSER_CLIENT;
  }
};

var isIframe$4 = function () {
    return self != top;
};
var isWPSClient = typeof window['cefQuery'] !== 'undefined' || typeof window['wpsQuery'] !== 'undefined';
function randString$3(namespace) {
    if (namespace === void 0) { namespace = 'dcm'; }
    var d = +new Date();
    var randNumber = Math.floor(Math.random() * 1000000);
    return "_".concat(d + randNumber, "_").concat(namespace);
}
var getCallbackFn = function (cb, fnStr, params, isStay) {
    fnStr = fnStr.split('.').join('_');
    var fnName = '_clientCallBack' + fnStr + randString$3();
    var w = isIframe$4() ? window.top : window;
    if (w) {
        w[fnName] = function (result) {
            cb(result);
            !isStay && delete w[fnName];
        };
        var cbFn_1 = params && params.callbackName;
        if (cbFn_1) {
            var cbName_1 = '_clientCallBack' + fnStr + randString$3();
            w[cbName_1] = function (result) {
                cbFn_1(result);
                !isStay && delete w[cbName_1];
            };
            params.callbackName = cbName_1;
        }
        return 'window.' + fnName;
    }
};
/**
 *
 * @string fnStr
 * @array argObjs [{key:xxx,value:xxx}] or {key1: value1, key2: value2}
 * @fn cb
 */
var callWPSClientAPI = function (fnStr, argObjs, cb, isStay) {
    if (!isWPSClient)
        return;
    argObjs = argObjs || [];
    var params = {};
    var argObj;
    var key;
    var value;
    if (Array.isArray(argObjs)) {
        for (var i = 0; i < argObjs.length; i++) {
            argObj = argObjs[i];
            key = argObj.key;
            value = argObj.value;
            params[key] = value;
        }
        // argObjs is Object
    }
    else {
        for (key in argObjs) {
            value = argObjs[key];
            params[key] = value;
        }
    }
    try {
        params.method = fnStr;
        var initCb = cb ? cb : function () { };
        var callback = getCallbackFn(initCb, fnStr, params.params, isStay);
        params.callback = callback;
        // if (params.params) {
        //     params.params.callbackName = callback
        // }
        var cefParams = {
            request: "fromJSAsynCall('" + JSON.stringify(params) + "')",
            persistent: false,
        };
        var queryFn = window['cefQuery'] || window['wpsQuery'];
        queryFn && queryFn(cefParams);
    }
    catch (e) {
        var clientErr = void 0;
        try {
            clientErr = JSON.stringify(e);
        }
        catch (err) {
            clientErr = e;
        }
        /* eslint-disable */
        console.error('call client api fail:', clientErr);
    }
};
// 结果转换返回
var transitionJsonParse = function (data) {
    var res = {};
    try {
        if (data != null) {
            res = JSON.parse(data);
        }
    }
    catch (_a) { }
    var result = res.result, callstatus = res.callstatus, errormsg = res.errormsg, otherResult = __rest(res, ["result", "callstatus", "errormsg"]);
    callstatus = result !== undefined ? result : callstatus;
    return { callstatus: callstatus, errormsg: errormsg, otherResult: otherResult };
};
// 调用接口返回结果回调
var apiCallback$4 = function (cb, funcName) { return function (data) {
    if (!cb)
        return;
    var _a = transitionJsonParse(data) || {}, callstatus = _a.callstatus, errormsg = _a.errormsg, otherResult = _a.otherResult;
    window.logic && window.logic.report('multi_account', "wps-client API\u540D\u79F0\u662F".concat(funcName, "\uFF0C\u8C03\u7528\u63A5\u53E3\u8FD4\u56DE\u7ED3\u679C ").concat(callstatus));
    cb(callstatus, errormsg, otherResult);
}; };
/**
 * @desc 调用接口成功与否判断
 * 备注：用于登录帐号、切换帐号异步调用。接口返回结果需要监听处理
 */
var apiCallResult = function (cb, funcName) { return function (data) {
    var _a = transitionJsonParse(data) || {}, callstatus = _a.callstatus, errormsg = _a.errormsg;
    // 如果调用接口不成功，则判直接判断为失败。接口返回结果是需要监听来获取。避免接口调用成功误认为是接口返回结果成功处理
    window.logic && window.logic.report('multi_account', "wps-client API\u540D\u79F0\u662F".concat(funcName, " \u76D1\u542C\u63A5\u53E3\u8C03\u7528\u662F\u5426\u6210\u529F ").concat(callstatus));
    if (callstatus !== 'ok' && cb) {
        cb(callstatus, errormsg);
    }
}; };
// 等待多个监听结果，用于添加账号和普通切换账号
var waitListenerResult = function (callback, resultLen) {
    var waitResultList = [];
    var timeoutID = null;
    var isStop = false;
    return function (data, eventName) {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function () {
            isStop = true;
            window.logic && window.logic.report('multi_account', "waitListenerResult \u6781\u7AEF\u5BB9\u9519\u5904\u7406\uFF0C10\u79D2\u6CA1\u6709\u7ED3\u679C\u76F4\u63A5\u89C6\u4E3A\u5931\u8D25");
            callback('fail');
        }, 10000); // 极端容错处理，10秒没有结果直接视为失败
        if (isStop)
            return;
        var _a = transitionJsonParse(data) || {}, callstatus = _a.callstatus, errormsg = _a.errormsg;
        // 只要存在失败，立马终止返回
        if (callstatus !== 'ok') {
            window.logic && window.logic.report('multi_account', "waitListenerResult \u76D1\u542C\u6DFB\u52A0/\u5207\u6362\u8D26\u53F7\u5B58\u5728\u5931\u8D25\uFF0C\u76D1\u542C\u4E8B\u4EF6".concat(eventName));
            clearTimeout(timeoutID);
            callback(callstatus, errormsg);
            return;
        }
        // 当结果数量匹配，说明已经获取所有的结果了，可以校验结果进行回调了
        waitResultList.push({ callstatus: callstatus, errormsg: errormsg });
        if (waitResultList.length === resultLen) {
            clearTimeout(timeoutID);
            var failInfo = waitResultList.find(function (item) { return item.callstatus !== 'ok'; });
            window.logic && window.logic.report('multi_account', "waitListenerResult \u76D1\u542C\u6DFB\u52A0/\u5207\u6362\u8D26\u53F7\u6574\u4F53\u7ED3\u679C\uFF1A".concat(failInfo ? (new URLSearchParams(waitResultList)).toString() : 'ok'));
            return failInfo ? callback(failInfo.callstatus, failInfo.errormsg) : callback('ok');
        }
    };
};
/**
 * 添加监听，common与插件方式，用于添加账号和普通切换账号
 * 备注: common.xx API是需要客户端走版本发布无法插件全量，非common是走插件的
 * */
var addListener = function (listenerNames, cb, listenerMode) {
    var _sleepFn = waitListenerResult(cb, listenerNames.length);
    var modeMap = {
        COMMON: 'common.event.addEventListener',
        PLUGIN: 'addEventListener',
    };
    // 监听结果
    listenerNames.forEach(function (eventName) {
        // 添加帐号监听结果
        callWPSClientAPI(modeMap[listenerMode], {
            params: {
                eventName: eventName,
                callbackName: function (info) { return _sleepFn(info, eventName); },
            },
        }, function () { }, true);
    });
};
// 清除监听添加监听，用于添加账号和普通切换账号
var removeListener = function (listenerNames) {
    listenerNames.forEach(function (eventName) {
        callWPSClientAPI('common.event.removeEventListener', {
            params: {
                eventName: eventName,
            }
        });
    });
};
/**
 * api哈希表
 */
var API_MAP$d = {
    openAppUpgrade: 'common.util.openUrl',
    addAccount: 'common.account.addAccount',
    switchAccount: 'common.account.switchAccount',
    openLogin: 'common.account.showLoginPageDlg',
    getLoginList: 'common.account.getAccountListInfo',
    getAppVersion: 'common.wpsoffice.getAppInfo',
    getCurrentSource: 'company.create.getSource',
    onAccountChange: 'common.event.addEventListener',
    addAccountByRandcode: 'addAccountByRandcode',
    closeWindow: 'closeWindow',
    openNewTab: 'openNewTab',
    login: 'common.account.login',
    closeWebView: 'common.webview.close',
    onCreateCompanySuccess: 'onCreateCompanySuccess',
    sendCommand: 'sendCommand',
    refreshCompanyList: 'refreshCompanyList',
    vbaRefreshCompanyList: 'vbapaycomponent.refreshCompanyList',
    getOemSupported: 'getOemSupported',
    checkCloudFeatureSupport: 'common.wpscloud.checkCloudFeatureSupport',
    openTagByVbaPay: 'common.payment.openTagByVbaPay',
    vbaSendCommand: 'vbapaycomponent.sendCommand',
    close: 'close',
    onComponentLoaded: 'onComponentLoaded',
    addDragArea: 'common.webview.addDragArea',
    updateRegistry: 'vbapaycomponent.updateRegistry',
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var functionList = [];
var checkApiSupport$d = function (apiName, cb) {
    var api = API_MAP$d[apiName];
    var isExist = false;
    if (!api)
        return cb(isExist);
    if (!functionList.length) {
        callWPSClientAPI('getFunctionList', {}, function (res) {
            functionList = Object.getPrototypeOf(res).constructor === Array ? res : [];
            isExist = functionList.some(function (item) { return item.function === api; });
        });
    }
    else {
        isExist = functionList === null || functionList === void 0 ? void 0 : functionList.some(function (item) { return item.function === api; });
    }
    if (isExist) {
        cb(isExist);
    }
    else {
        callWPSClientAPI('common.util.support', { params: { api: api } }, apiCallback$4(cb, api));
    }
    // if (!api.includes('common.')) {
    //     if (!functionList) {
    //         callWPSClientAPI('getFunctionList', {}, res => {
    //             functionList = Object.getPrototypeOf(res).constructor === Array ? res : []
    //             const isExist = functionList?.some(item => item.function === api)
    //             cb && cb(isExist)
    //         })
    //     } else {
    //         const isExist = functionList?.some(item => item.function === api)
    //         cb && cb(isExist)
    //     }
    //     return
    // }
    // if (api) {
    //     callWPSClientAPI('common.util.support', { params: { api } }, apiCallback(cb))
    // } else {
    //     cb && cb(false)
    // }
};
/**
 * @desc app升级
 */
var openAppUpgrade$7 = function () {
    var url = 'https://platform.wps.cn/';
    callWPSClientAPI(API_MAP$d.openAppUpgrade, { params: { url: url } });
};
/**
 * @desc 添加帐号
 */
var addAccount$b = function (ssid, userId, from, cb) {
    from = from || 'dcm';
    var LISTENER_NAMES = ['event.account.addaccount', 'event.account.login'];
    var fn = function () {
        var res = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            res[_i] = arguments[_i];
        }
        cb && cb.apply(void 0, res);
    };
    // 监听结果
    addListener(LISTENER_NAMES, fn, 'COMMON');
    // 客户端接口需要改变
    callWPSClientAPI(API_MAP$d.addAccount, { params: { ssid: ssid, userId: userId, source: from } }, apiCallResult(fn, API_MAP$d.addAccount));
};
/**
 * @desc 切換帐号
 */
var switchAccount$8 = function (userId, from, companyId, cb) {
    from = from || 'dcm';
    var LISTENER_NAMES = ['event.account.switchaccountfinished', 'event.account.login'];
    var fn = function () {
        var res = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            res[_i] = arguments[_i];
        }
        cb && cb.apply(void 0, res);
    };
    // 监听结果
    addListener(LISTENER_NAMES, fn, 'COMMON');
    callWPSClientAPI(API_MAP$d.switchAccount, {
        params: { userId: userId, companyId: companyId, source: from }
    }, apiCallResult(fn, API_MAP$d.switchAccount));
};
/**

 * @desc 调起登录页弹窗
 * 备注：由于该接口存在缺陷，没有api调用结果返回，已反馈@育校，预计24.10月版本后版本支持
 */
var openLoginDialog$9 = function (from, cb) {
    from = from || 'dcm';
    callWPSClientAPI(API_MAP$d.openLogin, { params: { source: from }, });
    cb('ok');
};
/**
 * @desc 获取多账号列表信息
 */
var getAccountListInfo$2 = function (cb) {
    // 客户端接口需要改变
    callWPSClientAPI(API_MAP$d.getLoginList, {}, apiCallback$4(cb, API_MAP$d.getLoginList));
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$a = function (cb) {
    callWPSClientAPI(API_MAP$d.getAppVersion, { params: {} }, apiCallback$4(cb, API_MAP$d.getAppVersion));
};
/**
 * @desc 进入企业
 */
var toEnterprise$a = function (companyid, groupid, iframeEventName, cb, additional) {
    var from = (additional || {}).from;
    var source = from ? "&1&1&".concat(from) : '';
    if (isIframe$4()) {
        window.logic && window.logic.report('multi_account', "wps-client toEnterprise This is iframe");
        // 适配当前打开的页面是通过pc的Iframe打开的
        iframeEventName && window.parent.postMessage(JSON.stringify({
            eventName: iframeEventName,
            companyid: companyid,
            tempId: groupid,
            groupId: groupid
        }), '*');
        return;
    }
    callWPSClientAPI('sendCommand', {
        params: {
            cmd: "plugin://pageStartPage?locateCloudCompany&activate&".concat(companyid).concat(source),
        },
    }, apiCallback$4(cb, 'toEnterprise: 调用进入sendCommand => pageStartPage'));
    setTimeout(function () {
        var clientName = index_cjs.getCurrentClient();
        window.logic && window.logic.report('multi_account', "wps-client toEnterprise close, clientName: ".concat(clientName));
        // mac需要特殊关闭
        if (clientName === 'isWpsMacClient') {
            callWPSClientAPI('close', {
                params: {
                    webviewId: 'dcm',
                },
            });
        }
        else {
            checkApiSupport$d(API_MAP$d.closeWindow, function (isExist) {
                isExist ? callWPSClientAPI(API_MAP$d.closeWindow, {}) : window.close();
            });
        }
    }, 1000);
};
/**
 * @desc 获取当前容器来源
 */
var getCurrentSource = function (cb) {
    callWPSClientAPI(API_MAP$d.getCurrentSource, { params: {} }, apiCallback$4(cb, API_MAP$d.getCurrentSource));
};
var onAccountChange = function (handler) {
    callWPSClientAPI('common.event.addEventListener', {
        params: {
            eventName: 'event.account.login',
            callbackName: handler || function () { }
        },
    });
};
/**
 * @desc 通过randcode添加账号
 * 备注：商业版登录流程
 */
var addAccountByRandcode = function (code, from, cb) {
    from = from || 'dcm';
    var LISTENER_NAMES = ['event.addAccountByRandcode'];
    var fn = function () {
        var res = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            res[_i] = arguments[_i];
        }
        cb && cb.apply(void 0, res);
    };
    // 监听结果
    addListener(LISTENER_NAMES, fn, 'PLUGIN');
    callWPSClientAPI(API_MAP$d.addAccountByRandcode, { params: { randcode: code, source: from } }, apiCallResult(fn, API_MAP$d.addAccountByRandcode));
};
/**
 * @desc 打开新tab
 */
var openNewTab = function (url) {
    callWPSClientAPI(API_MAP$d.openNewTab, { params: { url: url } });
};
/**
 * @desc login
 */
var login = function (cb) {
    callWPSClientAPI(API_MAP$d.login, {
        api: 'fromJSAsynCallBase64',
        params: {
            extraParams: {
                loginPage: 'Account',
            },
        },
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 关闭弹窗
 */
var closeDialog = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.closeWebView, {
        params: params || {},
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 通知客户端创建成功
 */
var createCompanySuccess = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.onCreateCompanySuccess, {
        params: params || {},
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 执行cmd
 */
var sendCommand = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.sendCommand, {
        params: params || {},
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 刷新企业列表
 */
var refreshCompanyList = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.refreshCompanyList, {
        params: params || {},
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 打开url
 */
var openUrl = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.openAppUpgrade, {
        params: params || {},
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 刷新vba列表
 */
var refreshVbaCompanyList = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.vbaRefreshCompanyList, {
        params: params || {},
    }, cb);
};
/**
 * @desc 获取是否教育版
 */
var getOemSupported = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.getOemSupported, {
        params: params || {},
    }, cb);
};
/**
 * @desc 获取是否教育版
 */
var checkCloudFeatureSupport = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.checkCloudFeatureSupport, {
        params: params || {},
    }, cb);
};
/**
 * @desc vba容器打开新tab
 */
var openTagByVbaPay = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.openTagByVbaPay, {
        params: params || {},
    }, cb);
};
/**
 * @desc close
 */
var close = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.close, {
        params: params || {}
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc 通知组件加载完成
 */
var onComponentLoaded = function () {
    callWPSClientAPI(API_MAP$d.onComponentLoaded);
};
/**
 * @desc 添加新容器
 */
var addDragArea = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.addDragArea, {
        params: params || {}
    }, function (res) {
        cb && cb(res);
    });
};
/**
 * @desc vba更新创建企业
 */
var updateRegistry = function (_a) {
    var params = _a.params, cb = _a.cb;
    callWPSClientAPI(API_MAP$d.updateRegistry, {
        params: params || {}
    }, function (res) {
        cb && cb(res);
    });
};

/**
 * api哈希表
 */
var API_MAP$c = {
    switchAccount: 'switchAccount',
    addAccount: 'loginChangeAccount',
    openLogin: 'loginMultiAccount',
    getLoginList: 'getAccountListInfo',
    getAppVersion: 'getAppVersion',
    openAppUpgrade: 'openSafari',
    toEnterprise: 'switchDocumentTab',
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$c = function (apiName, cb) {
    var _a;
    var api = API_MAP$c[apiName];
    if ((typeof api === 'boolean' && api) || ((_a = window === null || window === void 0 ? void 0 : window.wps) === null || _a === void 0 ? void 0 : _a[api])) {
        cb && cb(true);
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc app升级
 */
var openAppUpgrade$6 = function () {
    window.wps["".concat(API_MAP$c.openAppUpgrade)]({ url: 'itms-apps://itunes.apple.com/cn/app/id599852710?mt=8' });
};
var toEnterprise$9 = function (companyid, companyname) {
    window.wps["".concat(API_MAP$c.toEnterprise)]({
        companyId: companyid,
        companyName: companyname,
        showCompanyGuide: 1
    });
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$8 = function (cbURL) {
    window.wps["".concat(API_MAP$c.openLogin)]({
        openUrl: cbURL,
        complete: function (res) {
            var isFinished = res.code === 0;
            if (isFinished && !cbURL) {
                window.location.href = 'wpsoffice://wps.cn/handle_req/switchDocumentTab';
            }
        }
    });
};
/**
 * @desc 请求结果统一处理
 */
var apiCallback$3 = function (res, cb, funcName) {
    var _a = res || {}, code = _a.code, error_msg = _a.error_msg;
    var callstatus = code === 0 ? 'ok' : 'fail';
    window.logic && window.logic.report('multi_account', "wps IOS API\u540D\u79F0\u662F".concat(funcName, " \u8C03\u7528\u63A5\u53E3\u8FD4\u56DE\u7ED3\u679C: ").concat(callstatus));
    cb && cb(callstatus, error_msg);
};
/**
 * @desc 切換帐号
 */
var switchAccount$7 = function (userid, from, companyid, cbURL, cb) {
    from = from || 'dcm';
    if (window.logic && !window.wps[API_MAP$c.switchAccount]) {
        window.logic.report('multi_account', 'wps IOS window 没有挂载switchAccount');
    }
    window.wps["".concat(API_MAP$c.switchAccount)]({
        userId: userid,
        companyId: companyid,
        source: from,
        openUrl: cbURL,
        complete: function (res) {
            apiCallback$3(res, cb, API_MAP$c.switchAccount);
        }
    });
};
/**
 * @desc 登录账号
 */
var addAccount$a = function (ssid, userid, from, cb) {
    from = from || 'dcm';
    // 检查 window.logic 是否存在，并且 window.wps 中是否有对应的 API
    if (window.logic && !window.wps[API_MAP$c.addAccount]) {
        window.logic.report('multi_account', 'wps IOS window 没有挂载addAccount');
    }
    window.wps["".concat(API_MAP$c.addAccount)]({
        ssid: ssid,
        userId: userid,
        source: from,
        complete: function (res) {
            apiCallback$3(res, cb, API_MAP$c.addAccount);
        }
    });
};
/**
 * @desc 获取多账号列表信息
 */
var getAccountListInfo$1 = function (cb) {
    window.wps["".concat(API_MAP$c.getLoginList)]({
        complete: function (res) {
            try {
                var _a = res || {}, code = _a.code, error_msg = _a.error_msg;
                var callstatus = code === 0 ? 'ok' : 'fail';
                var accountlistinfo = res.accountlistinfo ? JSON.parse(res.accountlistinfo) : null;
                var otherResult = { accountlistinfo: accountlistinfo };
                cb(callstatus, error_msg, otherResult);
            }
            catch (e) {
                cb('fail');
            }
        }
    });
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$9 = function (cb) {
    window.wps["".concat(API_MAP$c.getAppVersion)]({
        complete: function (res) {
            var _a = res || {}, code = _a.code, error_msg = _a.error_msg, data = _a.data;
            var callstatus = code === 0 ? 'ok' : 'fail';
            var version = data === null || data === void 0 ? void 0 : data.app_version;
            cb && cb(callstatus, error_msg, { version: version });
        }
    });
};

/**
 * api哈希表
 */
var API_MAP$b = {
    switchAccount: 'switchAccount',
    addAccount: 'loginChangeAccount',
    openLogin: 'loginMultiAccount',
    getLoginList: 'getAccountListInfo',
    getAppVersion: 'getAppVersion',
    toEnterprise: true,
    openAppUpgrade: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$b = function (apiName, cb) {
    var _a;
    var api = API_MAP$b[apiName];
    if ((typeof api === 'boolean' && api) || ((_a = window === null || window === void 0 ? void 0 : window.wps) === null || _a === void 0 ? void 0 : _a[api])) {
        cb && cb(true);
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc app升级
 */
var openAppUpgrade$5 = function () {
    window.location.href = 'market://details?id=cn.wps.moffice_eng';
};
/**
 * @desc 进入企业
 */
var toEnterprise$8 = function (companyid) {
    window.location.href = "wpsoffice://wps.cn/root?key_switch_tab=document&key_open_companyid=".concat(companyid, "&showCompanyGuide=1");
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$7 = function (cbURL) {
    window.wps["".concat(API_MAP$b.openLogin)]({
        openUrl: cbURL,
        complete: function (res) {
            var isFinished = res.code === 0;
            if (isFinished && !cbURL) {
                window.location.href = 'wpsoffice://wps.cn/root?key_switch_tab=document';
            }
        }
    });
};
/**
 * @desc 请求结果统一处理
 */
var apiCallback$2 = function (res, cb, funcName) {
    var _a = res || {}, code = _a.code, error_msg = _a.error_msg;
    var callstatus = code === 0 ? 'ok' : 'fail';
    window.logic && window.logic.report('multi_account', "wps\u5B89\u5353 API\u540D\u79F0\u662F".concat(funcName, ", \u8C03\u7528\u63A5\u53E3\u8FD4\u56DE\u7ED3\u679C: ").concat(callstatus));
    cb && cb(callstatus, error_msg);
};
/**
 * @desc 切換帐号
 */
var switchAccount$6 = function (userid, from, companyid, cbURL, cb) {
    from = from || 'dcm';
    if (window.logic && !window.wps[API_MAP$b.switchAccount]) {
        window.logic.report('multi_account', 'wps安卓 window 没有挂载switchAccount');
    }
    window.wps["".concat(API_MAP$b.switchAccount)]({
        userId: userid,
        companyId: companyid,
        source: from,
        openUrl: cbURL,
        complete: function (res) {
            apiCallback$2(res, cb, API_MAP$b.switchAccount);
        }
    });
};
/**
 * @desc 登录账号
 */
var addAccount$9 = function (ssid, userid, from, cb) {
    from = from || 'dcm';
    if (window.logic && !window.wps[API_MAP$b.addAccount]) {
        window.logic.report('multi_account', 'wps安卓 window 没有挂载addAccount');
    }
    window.wps["".concat(API_MAP$b.addAccount)]({
        ssid: ssid,
        userId: userid,
        source: from,
        complete: function (res) {
            apiCallback$2(res, cb, API_MAP$b.addAccount);
        }
    });
};
/**
 * @desc 获取多账号列表信息
 */
var getAccountListInfo = function (cb) {
    window.wps["".concat(API_MAP$b.getLoginList)]({
        complete: function (res) {
            try {
                var _a = res || {}, code = _a.code, error_msg = _a.error_msg;
                var callstatus = code === 0 ? 'ok' : 'fail';
                var accountlistinfo = res.accountlistinfo ? JSON.parse(res.accountlistinfo) : null;
                var otherResult = { accountlistinfo: accountlistinfo };
                cb(callstatus, error_msg, otherResult);
            }
            catch (e) {
                cb('fail');
            }
        }
    });
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$8 = function (cb) {
    window.wps["".concat(API_MAP$b.getAppVersion)]({
        complete: function (res) {
            var _a = res || {}, code = _a.code, error_msg = _a.error_msg, data = _a.data;
            var callstatus = code === 0 ? 'ok' : 'fail';
            var version = data === null || data === void 0 ? void 0 : data.app_version;
            cb && cb(callstatus, error_msg, { version: version });
        }
    });
};

var isIframe$3 = function () {
    return self != top;
};
var getClientApi = function (attr) {
    var win = window;
    if (isIframe$3()) {
        try {
            document.domain = 'kdocs.cn';
            win = window.top;
        }
        catch (e) { }
    }
    var result = (win === null || win === void 0 ? void 0 : win["".concat(attr)]) || {};
    return result;
};
/**
 * api哈希表
 */
var API_MAP$a = {
    addAccount: 'kdesktopLogin',
    switchAccount: 'switchAccount',
    openLogin: 'openLoginDialog',
    openAppUpgrade: true,
    getAppVersion: true,
    toEnterprise: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$a = function (apiName, cb) {
    var api = API_MAP$a[apiName];
    var accountApi = getClientApi('account');
    if (api && (typeof api === 'boolean' || accountApi[api])) {
        cb && cb(true);
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc 进入企业
 */
var toEnterprise$7 = function (companyid) {
    window.parent.postMessage(JSON.stringify({
        eventName: 'desktop_home_switch',
        companyId: companyid,
    }), '*');
    setTimeout(function () { return window.close(); }, 500);
};
/**
 * @desc app升级
 */
var openAppUpgrade$4 = function () {
    var electron = getClientApi('electron');
    electron.shell.openExternal('https://www.kdocs.cn/welcome');
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$6 = function (cbURL) {
    var accountApi = getClientApi('account');
    if (accountApi.openLoginDialog) {
        var openUrl = cbURL;
        if (openUrl) {
            openUrl = decodeURIComponent(openUrl);
        }
        accountApi.openLoginDialog({ openUrl: openUrl });
    }
};
/**
 * @desc 切換帐号
 */
var switchAccount$5 = function (userid, companyid, cbURL, cb) {
    var accountApi = getClientApi('account');
    if (accountApi.switchAccount) {
        var openUrl = cbURL;
        if (openUrl) {
            openUrl = decodeURIComponent(openUrl);
        }
        accountApi.switchAccount({
            userid: Number(userid),
            company_id: Number(companyid),
            openUrl: openUrl,
        }, function (res) { return cb && cb(res.callstatus, res.errormsg); });
    }
};
/**
 * @desc 登录帐号
 */
var addAccount$8 = function (ssid, userid, cb) {
    var accountApi = getClientApi('account');
    if (accountApi.kdesktopLogin) {
        accountApi.kdesktopLogin({
            userid: Number(userid),
            ssid: ssid,
        }, function (res) { return cb && cb(res.result, res.msg); });
    }
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$7 = function () {
    var _a, _b;
    var ua = navigator.appVersion;
    var result = ua === null || ua === void 0 ? void 0 : ua.match(/kdesktop\/\d+(\.\d+)+/ig);
    var version = ((_b = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) || '';
    return { version: version };
};

var isIframe$2 = function () {
    return self != top;
};
function randString$2(namespace) {
    var d = +new Date();
    var randNumber = Math.floor(Math.random() * 1000000);
    return "_".concat(d + randNumber, "_").concat(namespace, "_");
}
var NAMESPACE$1 = 'invokeKDocsApi';
var invoke$4 = function (api, options, callback) {
    var _a = options || {}, namespace = _a.namespace, other = __rest(_a, ["namespace"]);
    namespace = namespace || NAMESPACE$1;
    var rand = randString$2(namespace);
    var onSuccess = "IOS_CB_SUCCESS".concat(rand);
    var onFail = "IOS_CB_FAIL".concat(rand);
    return new Promise(function (resolve, reject) {
        var _a;
        var win = isIframe$2() ? window.top : window;
        if (win) {
            // callstatus个别旧接口可能不存在的情况，属于客户端问题
            win[onSuccess] = function (params) {
                var data = (params || {}).data;
                callback && callback('ok', data);
                resolve(params);
            };
            win[onFail] = function (params) {
                callback && callback('fail');
                reject();
            };
        }
        (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers[namespace].postMessage(Object.assign({
            apiName: api,
            onSuccess: onSuccess,
            onFail: onFail,
        }, other || {}));
    });
};
/**
 * api哈希表
 */
var API_MAP$9 = {
    openAppUpgrade: 'openAppStore',
    toEnterprise: 'navigateToTab',
    openLogin: 'loginAppToLogin',
    switchAccount: 'loginAppChangeLogin',
    addAccount: 'loginMineAddLogin',
    getAppVersion: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$9 = function (apiName, cb) {
    var api = API_MAP$9[apiName];
    invoke$4('apiList', null, function (callstatus, data) {
        if (data === void 0) { data = []; }
        if (api && (typeof api === 'boolean' || data.includes(api))) {
            cb && cb(true);
        }
        else {
            cb && cb(false);
        }
    });
};
/**
 * @desc app升级
 */
var openAppUpgrade$3 = function () {
    invoke$4('openAppStore');
};
/**
 * @desc 进入企业
 */
var toEnterprise$6 = function (companyid, type, companyname) {
    var params = { type: type, companyid: companyid, companyname: companyname };
    invoke$4('navigateToTab', { params: params });
};
// 打开登录页弹窗 备注： 不会返回结果，所以不会有回调
var openLoginDialog$5 = function (cbURL) {
    var params = { openUrl: cbURL };
    invoke$4('loginAppToLogin', { params: params });
};
/**
 * @desc 切換帐号
 */
var switchAccount$4 = function (userid, companyid, cbURL, cb) {
    var openUrl = cbURL;
    if (openUrl) {
        openUrl = decodeURIComponent(openUrl);
    }
    var params = { userid: userid, companyId: companyid, openUrl: openUrl };
    invoke$4('loginAppChangeLogin', { params: params }, cb);
};
/**
 * @desc 登录帐号
 */
var addAccount$7 = function (ssid, userid, companyid, cb) {
    var params = { ssid: ssid, userid: userid, companyId: companyid };
    invoke$4('loginMineAddLogin', { params: params }, cb);
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$6 = function () {
    var _a, _b;
    var ua = navigator.appVersion;
    var result = ua === null || ua === void 0 ? void 0 : ua.match(/m-kdocs\/\d+(\.\d+)+/ig);
    var version = ((_b = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) || '';
    return { version: version };
};

var isIframe$1 = function () {
    return self != top;
};
function randString$1(namespace) {
    var d = +new Date();
    var randNumber = Math.floor(Math.random() * 1000000);
    return "_".concat(d + randNumber, "_").concat(namespace, "_");
}
var NAMESPACE = 'invokeKDocsApi';
var invoke$3 = function (api, options, callback) {
    var serviceName = 'yun';
    var _a = options || {}, namespace = _a.namespace, cbNmae = _a.cbNmae, other = __rest(_a, ["namespace", "cbNmae"]);
    namespace = namespace || NAMESPACE;
    var rand = randString$1(namespace);
    var _cbNmae = cbNmae || "AN_CB_invokeKDocsApi_".concat(rand);
    var paramsString = JSON.stringify(other);
    return new Promise(function (resolve, reject) {
        var _a;
        var win = isIframe$1() ? window.top : window;
        if (win && !cbNmae) {
            // callstatus个别旧接口可能不存在的情况，属于客户端问题
            win[_cbNmae] = function (params) {
                var res = 'fail';
                try {
                    // 特别备注：由于历史原因，客户端返回的可能是一个数组也是视为成功
                    var parseParams = JSON.parse(params);
                    var result = (parseParams || {}).result;
                    var isArray = Object.prototype.toString.call(parseParams) === '[object Array]';
                    var resultInfo = isArray ? parseParams : undefined;
                    if (result || isArray) {
                        res = 'ok';
                        resolve(params);
                    }
                    else {
                        reject(params);
                    }
                    callback && callback(res, resultInfo);
                }
                catch (e) {
                    callback && callback(res);
                    reject(e);
                }
            };
        }
        (_a = win === null || win === void 0 ? void 0 : win.WPSDoc) === null || _a === void 0 ? void 0 : _a.invoke(serviceName, api, paramsString, _cbNmae);
    });
};
/**
 * api哈希表
 */
var API_MAP$8 = {
    openAppUpgrade: 'openAppStore',
    toEnterprise: 'navigateToTab',
    openLogin: 'loginAppToLogin',
    switchAccount: 'loginAppChangeLogin',
    addAccount: 'loginMineAddLogin',
    getAppVersion: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$8 = function (apiName, cb) {
    var api = API_MAP$8[apiName];
    invoke$3('apiList', null, function (callstatus, data) {
        if (data === void 0) { data = []; }
        if (api && (typeof api === 'boolean' || data.includes(api))) {
            cb && cb(true);
        }
        else {
            cb && cb(false);
        }
    });
};
/**
 * @desc app升级
 */
var openAppUpgrade$2 = function () {
    invoke$3('openAppStore');
};
/**
 * @desc 进入企业
 */
var toEnterprise$5 = function (companyid, type, companyname) {
    var params = { type: type, companyid: companyid, companyname: companyname };
    invoke$3('navigateToTab', params);
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$4 = function (cbURL) {
    var params = { openUrl: cbURL };
    invoke$3('loginAppToLogin', params);
};
/**
 * @desc 切換帐号
 */
var switchAccount$3 = function (userid, companyid, cbURL, cb) {
    var openUrl = cbURL;
    if (openUrl) {
        openUrl = decodeURIComponent(openUrl);
    }
    var params = { userid: userid, companyId: companyid, openUrl: openUrl };
    invoke$3('loginAppChangeLogin', params, cb);
};
/**
 * @desc 登录帐号
 */
var addAccount$6 = function (ssid, userid, companyid, cb) {
    var params = { ssid: ssid, companyId: companyid, userid: userid };
    invoke$3('loginMineAddLogin', params, cb);
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$5 = function () {
    var _a, _b;
    var ua = navigator.appVersion;
    var result = ua === null || ua === void 0 ? void 0 : ua.match(/m-kdocs\/\d+(\.\d+)+/ig);
    var version = ((_b = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) || '';
    return { version: version };
};

function loadScript$1(onload) {
    var wxSdk = document.createElement('script');
    wxSdk.src = 'https://ks3.wpsplus.wpscdn.cn/img/client-connect-jweixin-1.6.0.js';
    wxSdk.type = 'text/javascript';
    wxSdk.onload = function () { return onload && onload(); };
    document.body.appendChild(wxSdk);
}
/**
 * api哈希表
 */
var API_MAP$7 = {
    toEnterprise: true,
    switchAccount: true,
    addAccount: true,
    openLogin: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$7 = function (apiName, cb) {
    var _a, _b;
    var api = API_MAP$7[apiName];
    if (api) {
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch) {
            cb && cb(true);
        }
        else {
            var onload_1 = cb ? function () { return cb(true); } : null;
            loadScript$1(onload_1);
        }
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc 进入企业
 */
var toEnterprise$4 = function (companyid) {
    var action = 'enter';
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({ url: "/pages/tabBars/teams/teams?action=".concat(action, "&companyid=").concat(companyid) });
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$3 = function (cbURL) {
    var _a, _b;
    var from = 'enterpriseCreation';
    (_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({ url: "/pages/accountPlugins/multipleAccountLogin/multipleAccountLogin?from=".concat(from, "&openurl=").concat(cbURL || '') });
};
/**
 * @desc 切換帐号
 */
var switchAccount$2 = function (userid, cbURL, companyid) {
    var action = 'switch';
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({ url: "/pages/tabBars/teams/teams?action=".concat(action, "&companyid=").concat(companyid, "&userid=").concat(userid, "&openurl=").concat(cbURL || '') });
};
/**
 * @desc 登录帐号
 */
var addAccount$5 = function (params) {
    var queryParams;
    var baseParams = "userid=".concat(params.userid).concat(params.companyid ? "&companyid=".concat(params.companyid) : '');
    window.logic && window.logic.report('multi_account', "addAccount authorizationCode: ".concat(params.authorizationCode, "\uFF0C codeVerifier\uFF1A").concat(params.codeVerifier));
    if ('ssid' in params) {
        queryParams = "ssid=".concat(params.ssid, "&").concat(baseParams);
    }
    else {
        queryParams = "authorizationCode=".concat(params.authorizationCode, "&codeVerifier=").concat(params.codeVerifier, "&").concat(baseParams);
    }
    var action = 'login';
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({
        url: "/pages/tabBars/teams/teams?action=".concat(action, "&").concat(queryParams)
    });
};

/**
 * api哈希表
 */
var API_MAP$6 = {
    toEnterprise: true,
    switchAccount: true,
    addAccount: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$6 = function (apiName, cb) {
    var api = API_MAP$6[apiName];
    if (api) {
        cb && cb(true);
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc 进入企业
 */
var toEnterprise$3 = function (companyid) {
    var _a, _b;
    var action = 'enter';
    (_b = (_a = window === null || window === void 0 ? void 0 : window.qq) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({ url: "/pages/tabBars/teams/teams?action=".concat(action, "&companyid=").concat(companyid) });
};
// 打开登录页弹窗 备注: QQ小程序830暂不支持；该能力依赖账号的登录组件。
// export const openLoginDialog = () => {
//     const from = 'enterpriseCreation'
//     window?.qq?.miniProgram?.reLaunch({ url: `/pages/accountPlugins/multipleAccountLogin/multipleAccountLogin?from=${from}` })
// }
/**
 * @desc 切換帐号
 */
var switchAccount$1 = function (userid, cbURL, companyid) {
    var _a, _b;
    var action = 'switch';
    (_b = (_a = window === null || window === void 0 ? void 0 : window.qq) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({ url: "/pages/tabBars/teams/teams?action=".concat(action, "&companyid=").concat(companyid, "&userid=").concat(userid, "&openurl=").concat(cbURL || '') });
};
/**
 * @desc 登录帐号
 */
var addAccount$4 = function (ssid, userid, companyid) {
    var _a, _b;
    var action = 'login';
    (_b = (_a = window === null || window === void 0 ? void 0 : window.qq) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({ url: "/pages/tabBars/teams/teams?action=".concat(action, "&companyid=").concat(companyid, "&ssid=").concat(ssid, "&userid=").concat(userid) });
};

var randString = function (namespace) {
    if (namespace === void 0) { namespace = ''; }
    var d = +new Date();
    var randNumber = Math.floor(Math.random() * 1000000);
    return "_".concat(d + randNumber, "_").concat(namespace, "_");
};
var isEncodedURIComponent = function (str) {
    try {
        return decodeURIComponent(str) !== str;
    }
    catch (e) {
        // 如果解码过程中抛出异常，说明字符串已经被编码
        return true;
    }
};
var getEncodedURL = function (str) {
    if (!str)
        return str;
    var isPass = isEncodedURIComponent(str);
    if (isPass) {
        return str;
    }
    else {
        return encodeURIComponent(str);
    }
};

var invoke$2 = function (api, options, callback) {
    var _a = options || {}, cbNmae = _a.cbNmae, other = __rest(_a, ["cbNmae"]);
    var rand = randString();
    var _cbNmae = cbNmae || "__woa_ios_client_api__".concat(rand);
    var params = {
        method: api,
        params: __assign({}, other),
        callback: _cbNmae
    };
    return new Promise(function (resolve, reject) {
        var _a, _b, _c;
        window[_cbNmae] = function (response) {
            if (response.callstatus === 'ok') {
                resolve(response);
                callback && callback('ok', response.result);
            }
            else {
                callback && callback('fail');
                reject(response);
            }
        };
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b['qing']) === null || _c === void 0 ? void 0 : _c.postMessage(params);
    });
};
/**
 * api哈希表
 */
var API_MAP$5 = {
    addAccount: true,
    getAppVersion: 'getAppInfo',
};
/**
 * 调用接口返回结果回调
 */
var apiCallback$1 = function (cb, funcName) { return function (callstatus, otherResult) {
    if (!cb)
        return;
    cb(callstatus, '', otherResult);
}; };
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$5 = function (apiName, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var api, res, status_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                api = API_MAP$5[apiName];
                if (!(typeof api === 'boolean' && api)) return [3 /*break*/, 1];
                cb && cb(true);
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, invoke$2('api.check', {
                    apis: [api]
                })];
            case 2:
                res = (_a.sent()) || {};
                status_1 = !!(res === null || res === void 0 ? void 0 : res.result[api]);
                cb && cb(status_1);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * @desc 登录账号
 */
var addAccount$3 = function (ssid, userid, from, cb) {
    invoke$2('loginChangeAccount', {
        ssid: ssid,
        userId: userid,
    }, cb);
};
/**
 * @desc 获取客户端信息
 */
var getAppVersion$4 = function (cb) {
    invoke$2(API_MAP$5.getAppVersion, {}, apiCallback$1(cb));
};

var invoke$1 = function (api, options, callback) {
    var _a = options || {}, cbNmae = _a.cbNmae, other = __rest(_a, ["cbNmae"]);
    var rand = randString();
    var _cbNmae = cbNmae || "__woa_an_client_api__".concat(rand);
    var params = {
        method: api,
        params: __assign({}, other),
        callback: _cbNmae
    };
    return new Promise(function (resolve, reject) {
        var _a;
        window[_cbNmae] = function (response) {
            if (response.callstatus === 'ok') {
                resolve(response);
                callback && callback('ok', response.result);
            }
            else {
                callback && callback('fail');
                reject(response);
            }
        };
        (_a = window === null || window === void 0 ? void 0 : window.qing) === null || _a === void 0 ? void 0 : _a.invoke(JSON.stringify(params));
    });
};
/**
 * api哈希表
 */
var API_MAP$4 = {
    addAccount: true,
    getAppVersion: 'getAppInfo',
};
/**
 * 调用接口返回结果回调
 */
var apiCallback = function (cb, funcName) { return function (callstatus, otherResult) {
    if (!cb)
        return;
    cb(callstatus, '', otherResult);
}; };
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$4 = function (apiName, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var api, res, status_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                api = API_MAP$4[apiName];
                if (!(typeof api === 'boolean' && api)) return [3 /*break*/, 1];
                cb && cb(true);
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, invoke$1('api.check', {
                    apis: [api]
                })];
            case 2:
                res = (_a.sent()) || {};
                status_1 = !!(res === null || res === void 0 ? void 0 : res.result[api]);
                cb && cb(status_1);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * @desc 登录账号
 */
var addAccount$2 = function (ssid, userid, from, cb) {
    invoke$1('loginChangeAccount', {
        ssid: ssid,
        userId: userid,
    }, cb);
};
/**
 * @desc 获取客户端信息
 */
var getAppVersion$3 = function (cb) {
    invoke$1(API_MAP$4.getAppVersion, {}, apiCallback(cb));
};

var setUrlQuery = function (url, params) {
    var querys = [];
    for (var key in params) {
        querys.push(key + '=' + String(params[key]));
    }
    return "".concat(url, "?").concat(querys.join('&'));
};
var redirectPage = function (params) {
    var PLUS = "https://plus.wps.cn";
    var url = setUrlQuery("".concat(PLUS, "/fab/client_connect_smooth_call/"), params);
    // @ts-ignore
    window === null || window === void 0 ? void 0 : window.top.location.href = url;
};
var isIframe = function () {
    return self != top;
};
function loadScript(onload) {
    console.log('pc 微信小程序');
    var wxSdk = document.createElement('script');
    wxSdk.src = 'https://ks3.wpsplus.wpscdn.cn/img/client-connect-jweixin-1.6.0.js';
    wxSdk.type = 'text/javascript';
    wxSdk.onload = function () { return onload && onload(); };
    document.body.appendChild(wxSdk);
}
/**
 * api哈希表
 */
var API_MAP$3 = {
    toEnterprise: true,
    switchAccount: true,
    addAccount: true,
    openLogin: true,
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$3 = function (apiName, cb) {
    var _a, _b;
    var api = API_MAP$3[apiName];
    if (api) {
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch) {
            cb && cb(true);
        }
        else {
            var onload_1 = cb ? function () { return cb(true); } : null;
            loadScript(onload_1);
        }
    }
    else {
        cb && cb(false);
    }
};
/**
 * @desc 进入企业
 */
var toEnterprise$2 = function (companyid) {
    var isStatus = isIframe();
    if (isStatus) {
        redirectPage({ companyid: companyid, apiName: 'toEnterprise' });
        return;
    }
    var action = 'enter';
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({ url: "/pages/pcweb/pcweb?action=".concat(action, "&companyid=").concat(companyid) });
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$2 = function (cbURL) {
    var _a, _b;
    var isStatus = isIframe();
    if (isStatus) {
        // iframe 不能进行cburl，不然会进行整个webView覆盖
        redirectPage({ cbURL: getEncodedURL(cbURL), apiName: 'openLogin' });
        return;
    }
    var from = 'enterpriseCreation';
    (_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({ url: "/pages/accountPlugins/multipleAccountLogin/multipleAccountLogin?from=".concat(from, "&openurl=").concat(getEncodedURL(cbURL) || '') });
};
/**
 * @desc 切換帐号
 */
var switchAccount = function (userid, cbURL, companyid) {
    var isStatus = isIframe();
    if (isStatus) {
        // iframe 不能进行cburl，不然会进行整个webView覆盖
        redirectPage({ userid: userid, companyid: companyid, cbURL: cbURL, apiName: 'switchAccount' });
        return;
    }
    var action = 'switch';
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({ url: "/pages/pcweb/pcweb?action=".concat(action, "&companyid=").concat(companyid, "&userid=").concat(userid, "&openurl=").concat(getEncodedURL(cbURL) || '') });
};
/**
 * @desc 登录帐号
 */
var addAccount$1 = function (params) {
    var isStatus = isIframe();
    var baseParams = {
        userid: params.userid,
        companyid: params.companyid,
        cbURL: getEncodedURL(params.cbURL),
        apiName: 'addAccount'
    };
    if (isStatus) {
        // iframe场景参数处理
        var redirectParams = 'ssid' in params ? __assign(__assign({}, baseParams), { ssid: params.ssid }) : // 该分支自动排除授权码参数
         __assign(__assign({}, baseParams), { authorizationCode: params.authorizationCode, codeVerifier: params.codeVerifier }); // 该分支自动排除ssid
        redirectPage(redirectParams);
        return;
    }
    // 构建URL参数
    var queryParams;
    if ('ssid' in params) {
        queryParams = "ssid=".concat(params.ssid);
    }
    else {
        queryParams = "authorizationCode=".concat(params.authorizationCode, "&codeVerifier=").concat(params.codeVerifier);
    }
    var action = 'login';
    var url = "/pages/pcweb/pcweb?action=".concat(action, "&").concat(queryParams, "&companyid=").concat(params.companyid || '', "&userid=").concat(params.userid, "&openurl=").concat(getEncodedURL(params.cbURL) || '');
    window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({ url: url });
};

var invoke = function (api, options, callback) {
    var _a = options || {}, cbNmae = _a.cbNmae, other = __rest(_a, ["cbNmae"]);
    var rand = randString();
    var _cbNmae = cbNmae || "__woa_pc_client_api__".concat(rand);
    var params = {
        method: api,
        params: __assign({}, other),
        callback: _cbNmae
    };
    return new Promise(function (resolve, reject) {
        window[_cbNmae] = function (response) {
            if (response.callstatus === 'ok') {
                resolve(response);
                callback && callback('ok', response.result);
            }
            else {
                callback && callback('fail');
                reject(response);
            }
        };
        window === null || window === void 0 ? void 0 : window.qing(params);
    });
};
/**
 * api哈希表
 * PC 端不支持API直接交互，原因：该端走了iframe方案，无法提供相关api交互能力，待他们整体去iframe话，走webview后再适配支持
 */
var API_MAP$2 = {
    // addAccount: 'loginChangeAccount', // 添加账号
    // getAppVersion: 'getAppInfo',
    addAccount: false,
    getAppVersion: true, // 由于无法直接api交互，所以默认支持，走User-Agent获取
};
/**
 * @desc 登录账号 webb
 */
var addAccount = function (ssid, userid, from, cb) {
    invoke(API_MAP$2.addAccount, {
        ssid: ssid,
        userId: userid,
    }, cb);
};
/**
 * @desc 获取客户端信息
 */
var getAppVersion$2 = function (cb) {
    var _a, _b;
    // invoke(API_MAP.getAppVersion, {}, apiCallback(cb))
    var versionRegex = /xiezuo\/([\d.]+)/;
    var versionMatch = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.match(versionRegex);
    var version = versionMatch ? versionMatch[1] : null;
    // 提取channel标识
    var channelRegex = /channel\/([a-zA-Z0-9_-]+)/;
    var channelMatch = (_b = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _b === void 0 ? void 0 : _b.match(channelRegex);
    var channel = channelMatch ? channelMatch[1] : null;
    // 返回结果对象
    console.log('日志PC 获取渠道', channel, version);
    cb('ok', '', { version: version, channel: channel });
};

/**
 * 添加帐号
 */
var AddAccount$1 = /** @class */ (function () {
    function AddAccount(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (res, msg) {
            console.info('添加账号日志', res, msg);
            if (res === 'ok' && typeof onSuccess === 'function') {
                window.logic && window.logic.report('multi_account', "callbackResult onSuccess ".concat(msg));
                onSuccess(msg);
            }
            if (res && res !== 'ok' && typeof onFail === 'function') {
                window.logic && window.logic.report('multi_account', "callbackResult onFail ".concat(msg));
                onFail(msg);
            }
        }; };
        this.addAccountParams = params;
    }
    AddAccount.prototype.wpsAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$b(ssid, userid, from, callback);
    };
    AddAccount.prototype.wpsIosAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$a(ssid, userid, from, callback);
    };
    AddAccount.prototype.wpsAnAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$9(ssid, userid, from, callback);
    };
    // 金山文档PC/MAC客户端
    AddAccount.prototype.docsAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$8(ssid, userid, callback);
    };
    // 金山文档IOS客户端
    AddAccount.prototype.docsIosAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, companyid = _a.companyid, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$7(ssid, userid, companyid, callback);
    };
    // 金山文档IOS客户端
    AddAccount.prototype.docsAnAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, companyid = _a.companyid, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccount$6(ssid, userid, companyid, callback);
    };
    AddAccount.prototype.wxminiprogramAddAccount = function () {
        // const { ssid, userid, companyid, } = this.addAccountParams as addAccountParams
        // wxminiprogramAddAccount(ssid, userid, companyid)
        this.addAccountParams;
        addAccount$5(this.addAccountParams);
    };
    AddAccount.prototype.qqminiprogramAddAccount = function () {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, companyid = _a.companyid;
        addAccount$4(ssid, userid, companyid);
    };
    AddAccount.prototype.pcWxminiprogramAddAccount = function () {
        // const { ssid, userid, companyid, cbURL } = this.addAccountParams as addAccountParams
        // pcWxminiprogramAddAccount(ssid, userid, companyid, cbURL)
        addAccount$1(this.addAccountParams);
    };
    // 通用私有方法，处理woa系列添加账号的逻辑
    AddAccount.prototype.woaAddAccountCommon = function (addAccountFunction) {
        var _a = this.addAccountParams, ssid = _a.ssid, userid = _a.userid, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccountFunction(ssid, userid, from, callback);
    };
    // 公开方法，保持原有API兼容性
    AddAccount.prototype.woaIosAddAccount = function () {
        this.woaAddAccountCommon(addAccount$3);
    };
    AddAccount.prototype.woaAnAddAccount = function () {
        this.woaAddAccountCommon(addAccount$2);
    };
    AddAccount.prototype.woaAddAccount = function () {
        this.woaAddAccountCommon(addAccount);
    };
    return AddAccount;
}());

/**
 * 添加帐号
 */
var AddAccount = /** @class */ (function () {
    function AddAccount(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (res, msg) {
            console.info('wpsAddAccountByRandcode日志', res, msg);
            if (res === 'ok' && typeof onSuccess === 'function') {
                onSuccess(msg);
            }
            if (res && res !== 'ok' && typeof onFail === 'function') {
                onFail(msg);
            }
        }; };
        this.addAccountByRandcodeParams = params;
    }
    AddAccount.prototype.wpsAddAccountByRandcode = function () {
        var _a = this.addAccountByRandcodeParams, code = _a.code, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        addAccountByRandcode(code, from, callback);
    };
    return AddAccount;
}());

/**
 * 添加帐号
 */
var Switchccount = /** @class */ (function () {
    function Switchccount(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (res, msg) {
            console.info('切换账号结果日志', res, msg);
            if (res === 'ok' && typeof onSuccess === 'function') {
                onSuccess(msg);
            }
            if (res && res !== 'ok' && typeof onFail === 'function') {
                onFail(msg);
            }
        }; };
        this.encodeCbURL = function (cbURL) {
            var isEncode = decodeURIComponent(cbURL) !== cbURL;
            var encodeCbURL = isEncode ? cbURL : encodeURIComponent(cbURL);
            return encodeCbURL;
        };
        this.switchAccountParams = params;
    }
    Switchccount.prototype.wpsSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        switchAccount$8(userid, from, companyid, callback);
    };
    Switchccount.prototype.wpsIosSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, from = _a.from, cbURL = _a.cbURL, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        switchAccount$7(userid, from, companyid, cbURL, callback);
    };
    Switchccount.prototype.wpsAnSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, from = _a.from, cbURL = _a.cbURL, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        switchAccount$6(userid, from, companyid, cbURL, callback);
    };
    Switchccount.prototype.docsSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, cbURL = _a.cbURL, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount$5(userid, companyid, _cbURL, callback);
    };
    Switchccount.prototype.docsIosSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, cbURL = _a.cbURL, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount$4(userid, companyid, _cbURL, callback);
    };
    Switchccount.prototype.docsAnSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, companyid = _a.companyid, cbURL = _a.cbURL, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount$3(userid, companyid, _cbURL, callback);
    };
    Switchccount.prototype.wxminiprogramSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, cbURL = _a.cbURL, companyid = _a.companyid;
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount$2(userid, _cbURL, companyid);
    };
    Switchccount.prototype.qqminiprogramSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, cbURL = _a.cbURL, companyid = _a.companyid;
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount$1(userid, _cbURL, companyid);
    };
    Switchccount.prototype.pcWxminiprogramSwitchAccount = function () {
        var _a = this.switchAccountParams, userid = _a.userid, cbURL = _a.cbURL, companyid = _a.companyid;
        var _cbURL = this.encodeCbURL(cbURL);
        switchAccount(userid, _cbURL, companyid);
    };
    return Switchccount;
}());

var transformAccountsInfo = function (list) { return list === null || list === void 0 ? void 0 : list.map(function (item) { return ({
    userid: parseInt(item.userId),
    nickname: item.nickName,
    avatar_url: item.avatarUrl,
    company_logo: item.company_logo,
    company_id: parseInt(item.companyId),
    company_name: item.companyName,
    is_company_account: item.is_company_account,
    status: item.status,
    reason: item.reason,
    is_current: item.is_current_login,
}); }); };
/**
 * 获取凭证组已登录列表
 */
var LoginList = /** @class */ (function () {
    function LoginList(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var accountlistinfo = (otherResult || {}).accountlistinfo;
                var accounts = transformAccountsInfo(accountlistinfo);
                onSuccess(accounts);
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        }; };
        this.loginListParams = params;
    }
    LoginList.prototype.wpsGetAccountListInfo = function () {
        var _a = this.loginListParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        getAccountListInfo$2(callback);
    };
    LoginList.prototype.wpsIosGetAccountListInfo = function () {
        var _a = this.loginListParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        getAccountListInfo$1(callback);
    };
    LoginList.prototype.wpsAnGetAccountListInfo = function () {
        var _a = this.loginListParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        getAccountListInfo(callback);
    };
    return LoginList;
}());

var setDomain$1 = function () {
    if (isIframe$2()) {
        try {
            document.domain = 'docs.wps.cn';
        }
        catch (e) { }
    }
};
/**
 * api哈希表
 */
var API_MAP$1 = {
    openLogin: 'loginOtherAccount',
    openAppUpgrade: 'openAppStore',
    getAppVersion: true,
    toEnterprise: true
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$2 = function (apiName, cb) {
    setDomain$1();
    var api = API_MAP$1[apiName];
    invoke$4('apiList', null, function (callstatus, data) {
        if (data === void 0) { data = []; }
        if (api && (typeof api === 'boolean' || data.includes(api))) {
            cb && cb(true);
        }
        else {
            cb && cb(false);
        }
    });
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog$1 = function () {
    invoke$4('loginOtherAccount');
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion$1 = function () {
    var _a, _b;
    var ua = navigator.appVersion;
    var result = ua === null || ua === void 0 ? void 0 : ua.match(/m-kdocs\/\d+(\.\d+)+/ig);
    var version = ((_b = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) || '';
    return { version: version };
};
/**
 * @desc 进入企业
 */
var toEnterprise$1 = function (companyid) {
    if (isIframe$2()) {
        window.parent.postMessage(JSON.stringify({
            eventName: 'toCompanyPage',
            companyid: companyid,
        }), '*');
    }
    else {
        var params = {
            apiName: 'toHomeByPath',
            params: {
                'homeUrl': "/ent/".concat(companyid, "/helper?n_redirect=0"),
                'closeCurrentPage': true
            }
        };
        invoke$4('toHomeByPath', { params: params });
    }
};
/**
 * @desc app升级
 */
var openAppUpgrade$1 = function () {
    invoke$4('openAppStore');
};

var setDomain = function () {
    if (isIframe$1()) {
        try {
            document.domain = 'kdocs.cn';
        }
        catch (e) { }
    }
};
/**
 * api哈希表
 */
var API_MAP = {
    openLogin: 'loginOtherAccount',
    openAppUpgrade: 'openAppStore',
    getAppVersion: true,
    toEnterprise: true
};
/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
var checkApiSupport$1 = function (apiName, cb) {
    setDomain();
    var api = API_MAP[apiName];
    invoke$3('apiList', null, function (callstatus, data) {
        if (data === void 0) { data = []; }
        if (api && (typeof api === 'boolean' || data.includes(api))) {
            cb && cb(true);
        }
        else {
            cb && cb(false);
        }
    });
};
/**
 * @desc 打开登录页弹窗
 */
var openLoginDialog = function () {
    invoke$3('loginOtherAccount');
};
/**
 * @desc 获取app 版本信息
 */
var getAppVersion = function () {
    var _a, _b;
    var ua = navigator.appVersion;
    var result = ua === null || ua === void 0 ? void 0 : ua.match(/m-kdocs\/\d+(\.\d+)+/ig);
    var version = ((_b = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) || '';
    return { version: version };
};
/**
 * @desc 进入企业
 */
var toEnterprise = function (companyid) {
    if (isIframe$1()) {
        window.parent.postMessage(JSON.stringify({
            eventName: 'toCompanyPage',
            companyid: companyid,
        }), '*');
    }
    else {
        var params = {
            apiName: 'toHomeByPath',
            cbNmae: 'emptyCb',
            homeUrl: "/ent/".concat(companyid, "/helper?n_redirect=0"),
            closeCurrentPage: true
        };
        invoke$3('toHomeByPath', params);
    }
};
/**
 * @desc app升级
 */
var openAppUpgrade = function () {
    invoke$3('openAppStore');
};

/**
 * 客户端登录引导
 */
var OpenLogin$1 = /** @class */ (function () {
    function OpenLogin(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (res, msg) {
            if (res === 'ok' && typeof onSuccess === 'function') {
                onSuccess(msg);
            }
            if (res && res !== 'ok' && typeof onFail === 'function') {
                onFail(msg);
            }
        }; };
        this.openLoginParams = params;
    }
    OpenLogin.prototype.wpsOpenLoginDialog = function () {
        var _a = this.openLoginParams, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        openLoginDialog$9(from, callback);
    };
    OpenLogin.prototype.wpsIosOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$8(cbURL);
    };
    OpenLogin.prototype.wpsAnOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$7(cbURL);
    };
    OpenLogin.prototype.docsOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$6(cbURL);
    };
    OpenLogin.prototype.docsIosOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$5(cbURL);
    };
    OpenLogin.prototype.docsAnOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$4(cbURL);
    };
    OpenLogin.prototype.docsIpadOpenLoginDialog = function () {
        openLoginDialog$1();
    };
    OpenLogin.prototype.docsAnPadOpenLoginDialog = function () {
        openLoginDialog();
    };
    OpenLogin.prototype.wxminiprogramOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$3(cbURL);
    };
    OpenLogin.prototype.pcWxminiprogramOpenLoginDialog = function () {
        var cbURL = this.openLoginParams.cbURL;
        openLoginDialog$2(cbURL);
    };
    return OpenLogin;
}());

var EnterpriseType;
(function (EnterpriseType) {
    EnterpriseType["team"] = "team";
    EnterpriseType["mine"] = "mine";
    EnterpriseType["star"] = "star";
    EnterpriseType["latest"] = "latest";
})(EnterpriseType || (EnterpriseType = {}));

/**
 * 客户端登录引导
 */
var OpenLogin = /** @class */ (function () {
    function OpenLogin(params) {
        this.callbackResult = function (onSuccess, onFail) { return function (res, msg) {
            if (res === 'ok' && typeof onSuccess === 'function') {
                onSuccess(msg);
            }
            if (res && res !== 'ok' && typeof onFail === 'function') {
                onFail(msg);
            }
        }; };
        this.toEnterpriseParams = params;
    }
    OpenLogin.prototype.docsIosToEnterprise = function () {
        var _a = this.toEnterpriseParams, _b = _a.type, type = _b === void 0 ? EnterpriseType.team : _b, companyid = _a.companyid, companyname = _a.companyname;
        toEnterprise$6(companyid, type, companyname);
    };
    OpenLogin.prototype.docsAnToEnterprise = function () {
        var _a = this.toEnterpriseParams, _b = _a.type, type = _b === void 0 ? EnterpriseType.team : _b, companyid = _a.companyid, companyname = _a.companyname;
        toEnterprise$5(companyid, type, companyname);
    };
    OpenLogin.prototype.docsIpadToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$1(companyid);
    };
    OpenLogin.prototype.docsAnPadToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise(companyid);
    };
    OpenLogin.prototype.wxminiprogramToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$4(companyid);
    };
    OpenLogin.prototype.qqminiprogramToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$3(companyid);
    };
    OpenLogin.prototype.pcWxminiprogramToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$2(companyid);
    };
    OpenLogin.prototype.wpsToEnterprise = function () {
        var _a = this.toEnterpriseParams, companyid = _a.companyid, groupid = _a.groupid, iframeEventName = _a.iframeEventName, from = _a.from, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = this.callbackResult(onSuccess, onFail);
        toEnterprise$a(companyid, groupid, iframeEventName, callback, { from: from });
    };
    OpenLogin.prototype.docsToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$7(companyid);
    };
    OpenLogin.prototype.wpsIosToEnterprise = function () {
        var _a = this.toEnterpriseParams, companyid = _a.companyid, _b = _a.companyname, companyname = _b === void 0 ? '' : _b;
        toEnterprise$9(companyid, companyname);
    };
    OpenLogin.prototype.wpsAnToEnterprise = function () {
        var companyid = this.toEnterpriseParams.companyid;
        toEnterprise$8(companyid);
    };
    return OpenLogin;
}());

/**
 * 更新客户端
 */
var OpenAppUpgrade = /** @class */ (function () {
    function OpenAppUpgrade() {
    }
    OpenAppUpgrade.prototype.docsIosOpenAppUpgrade = function () {
        openAppUpgrade$3();
    };
    OpenAppUpgrade.prototype.docsAnOpenAppUpgrade = function () {
        openAppUpgrade$2();
    };
    OpenAppUpgrade.prototype.docsIpadOpenAppUpgrade = function () {
        openAppUpgrade$1();
    };
    OpenAppUpgrade.prototype.docsAnPadOpenAppUpgrade = function () {
        openAppUpgrade();
    };
    OpenAppUpgrade.prototype.docsOpenAppUpgrade = function () {
        openAppUpgrade$4();
    };
    OpenAppUpgrade.prototype.wpsOpenAppUpgrade = function () {
        openAppUpgrade$7();
    };
    OpenAppUpgrade.prototype.wpsIosOpenAppUpgrade = function () {
        openAppUpgrade$6();
    };
    OpenAppUpgrade.prototype.wpsAnOpenAppUpgrade = function () {
        openAppUpgrade$5();
    };
    return OpenAppUpgrade;
}());

/*
 * -----------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office, All rights reserved.
 * -----------------------------------------------------------------------------
 */
/**
 * 获取app版本
 */
var appVersion = /** @class */ (function () {
    function appVersion(params) {
        this.appVersionParams = params;
    }
    appVersion.prototype.wpsGetAppVersion = function () {
        var _a = this.appVersionParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var _a = otherResult || {}, version = _a.version, channel = _a.channel;
                onSuccess({ version: version, channel: channel });
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        };
        getAppVersion$a(callback);
    };
    appVersion.prototype.wpsIosGetAppVersion = function () {
        var _a = this.appVersionParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var version = (otherResult || {}).version;
                onSuccess({ version: version });
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        };
        getAppVersion$9(callback);
    };
    appVersion.prototype.wpsAnGetAppVersion = function () {
        var _a = this.appVersionParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var version = (otherResult || {}).version;
                onSuccess({ version: version });
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        };
        getAppVersion$8(callback);
    };
    appVersion.prototype.docsGetAppVersion = function () {
        var onSuccess = this.appVersionParams.onSuccess;
        var result = getAppVersion$7();
        onSuccess && onSuccess(result);
    };
    appVersion.prototype.docsAnGetAppVersion = function () {
        var onSuccess = this.appVersionParams.onSuccess;
        var result = getAppVersion$5();
        onSuccess && onSuccess(result);
    };
    appVersion.prototype.docsAnPadGetAppVersion = function () {
        var onSuccess = this.appVersionParams.onSuccess;
        var result = getAppVersion();
        onSuccess && onSuccess(result);
    };
    appVersion.prototype.docsIosGetAppVersion = function () {
        var onSuccess = this.appVersionParams.onSuccess;
        var result = getAppVersion$6();
        onSuccess && onSuccess(result);
    };
    appVersion.prototype.docsIpadGetAppVersion = function () {
        var onSuccess = this.appVersionParams.onSuccess;
        var result = getAppVersion$1();
        onSuccess && onSuccess(result);
    };
    // 通用私有方法，处理woa系列获取版本号的逻辑
    appVersion.prototype.getWoaAppVersionCommon = function (getVersionFunction) {
        var _a = this.appVersionParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var _a = otherResult || {}, version = _a.version, channel = _a.channel;
                console.log('临时日志', otherResult, channel);
                onSuccess({ version: version, channel: channel });
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        };
        getVersionFunction(callback);
    };
    // 公开方法，保持原有API兼容性
    appVersion.prototype.woaGetAppVersion = function () {
        this.getWoaAppVersionCommon(getAppVersion$2);
    };
    appVersion.prototype.woaAnGetAppVersion = function () {
        this.getWoaAppVersionCommon(getAppVersion$3);
    };
    appVersion.prototype.woaIosGetAppVersion = function () {
        this.getWoaAppVersionCommon(getAppVersion$4);
    };
    return appVersion;
}());

var checkApiSupport = /** @class */ (function () {
    function checkApiSupport(params) {
        this.callbackResult = function (cb) { return function (res) {
            cb && cb(res);
        }; };
        this.callClientApiSupportTypeParams = params;
    }
    checkApiSupport.prototype.wpsCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$d(apiName, callback);
    };
    checkApiSupport.prototype.docsCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$a(apiName, callback);
    };
    checkApiSupport.prototype.docsIosCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$9(apiName, callback);
    };
    checkApiSupport.prototype.docsAnCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$8(apiName, callback);
    };
    checkApiSupport.prototype.docsIpadCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$2(apiName, callback);
    };
    checkApiSupport.prototype.docsAnPadCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$1(apiName, callback);
    };
    checkApiSupport.prototype.qqminiprogramCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$6(apiName, callback);
    };
    checkApiSupport.prototype.wxminiprogramCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$7(apiName, callback);
    };
    checkApiSupport.prototype.pcWxminiprogramCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$3(apiName, callback);
    };
    checkApiSupport.prototype.wpsIosCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$c(apiName, callback);
    };
    checkApiSupport.prototype.wpsAnCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$b(apiName, callback);
    };
    checkApiSupport.prototype.woaIosCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$5(apiName, callback);
    };
    checkApiSupport.prototype.woaAnCheckApiSupport = function () {
        var _a = this.callClientApiSupportTypeParams, apiName = _a.apiName, cb = _a.cb;
        var callback = this.callbackResult(cb);
        checkApiSupport$4(apiName, callback);
    };
    return checkApiSupport;
}());

/**
 * 获取当前容器来源
 */
var currentSource = /** @class */ (function () {
    function currentSource(params) {
        this.getCurrentSourceParams = params;
    }
    currentSource.prototype.wpsGetCurrentSource = function () {
        var _a = this.getCurrentSourceParams, onSuccess = _a.onSuccess, onFail = _a.onFail;
        var callback = function (callstatus, errormsg, otherResult) {
            if (callstatus === 'ok' && otherResult && typeof onSuccess === 'function') {
                var source = (otherResult || {}).source;
                onSuccess({ source: source });
            }
            if (callstatus && callstatus !== 'ok' && typeof onFail === 'function') {
                onFail(errormsg);
            }
        };
        getCurrentSource(callback);
    };
    return currentSource;
}());

/**
 * 更新客户端
 */
var OnAccountChange = /** @class */ (function () {
    function OnAccountChange(params) {
        this.onAccountChangeParams = params;
    }
    OnAccountChange.prototype.wpsOnAccountChange = function () {
        var handler = this.onAccountChangeParams.handler;
        onAccountChange(function (res) {
            var info = {};
            try {
                var data = JSON.parse(res);
                info = {
                    userid: data.userId,
                    nickname: data.userName,
                };
            }
            catch (e) { }
            // @ts-ignore
            handler(info);
        });
    };
    return OnAccountChange;
}());

var OpenNewTab = /** @class */ (function () {
    function OpenNewTab(options) {
        this.openNewTabApiParams = options;
    }
    OpenNewTab.prototype.wpsOpenNewTab = function () {
        var url = this.openNewTabApiParams.url;
        openNewTab(url);
    };
    return OpenNewTab;
}());

var AddListener = /** @class */ (function () {
    function AddListener(options) {
        this.addListenerParams = options;
    }
    AddListener.prototype.wpsAddListener = function () {
        var _a = this.addListenerParams, listenerNames = _a.listenerNames, cb = _a.cb, _b = _a.listenerMode, listenerMode = _b === void 0 ? 'COMMON' : _b;
        if (!listenerNames)
            return false;
        addListener(listenerNames, cb, listenerMode);
    };
    return AddListener;
}());

var RemoveListener = /** @class */ (function () {
    function RemoveListener(options) {
        this.removeListenerParams = options;
    }
    RemoveListener.prototype.wpsRemoveListener = function () {
        var listenerNames = this.removeListenerParams.listenerNames;
        if (!listenerNames)
            return false;
        removeListener(listenerNames);
    };
    return RemoveListener;
}());

var Login$1 = /** @class */ (function () {
    function Login(options) {
        this.loginParams = options;
    }
    Login.prototype.wpsLogin = function () {
        var handler = this.loginParams.handler;
        login(handler);
    };
    return Login;
}());

/*
 * -----------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office, All rights reserved.
 * -----------------------------------------------------------------------------
 */
var wpsUtilsMap = {
    'common.webview.close': closeDialog,
    'onCreateCompanySuccess': createCompanySuccess,
    'common.util.support': checkApiSupport$d,
    'sendCommand': sendCommand,
    'refreshCompanyList': refreshCompanyList,
    'vbapaycomponent.refreshCompanyList': refreshVbaCompanyList,
    'getOemSupported': getOemSupported,
    'common.wpscloud.checkCloudFeatureSupport': checkCloudFeatureSupport,
    'common.payment.openTagByVbaPay': openTagByVbaPay,
    'close': close,
    'onComponentLoaded': onComponentLoaded,
    'common.webview.addDragArea': addDragArea,
    'vbapaycomponent.updateRegistry': updateRegistry,
    'common.util.openUrl': openUrl
};
var Login = /** @class */ (function () {
    function Login(options) {
        this.loginParams = options;
    }
    Login.prototype.wpsCallCommonApi = function () {
        var _a = this.loginParams, eventName = _a.eventName, data = _a.data;
        var action = wpsUtilsMap[eventName];
        if (!action) {
            throw new Error("@quick/client-connect wpsutils \u4E0D\u652F\u6301 ".concat(eventName));
        }
        try {
            if (!data) {
                action();
            }
            else if (Array.isArray(data)) {
                action.apply(void 0, data);
            }
            else {
                action(data);
            }
        }
        catch (e) {
            throw new Error("@quick/client-connect wpsutils ".concat(eventName, " \u62A5\u9519 ").concat(e));
        }
    };
    return Login;
}());

var ClientConnect = /** @class */ (function () {
    function ClientConnect() {
    }
    // 获取当前端
    ClientConnect.prototype.getCurrentClient = function () {
        return index_cjs.getCurrentClient();
    };
    // 检查端API是否支持多账号
    ClientConnect.prototype.checkClientAPISupport = function (clientName, apiName) {
        return new Promise(function (resolve, reject) {
            var cb = function (status) { return status ? resolve(true) : resolve(false); };
            var checkApiSupport$1 = new checkApiSupport({ apiName: apiName, cb: cb });
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.wpsCheckApiSupport();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.docsCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
                checkApiSupport$1.docsIosCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
                checkApiSupport$1.docsAnCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT === clientName) {
                checkApiSupport$1.docsIpadCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT === clientName) {
                checkApiSupport$1.docsAnPadCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT === clientName) {
                checkApiSupport$1.wxminiprogramCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT === clientName) {
                checkApiSupport$1.pcWxminiprogramCheckApiSupport();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_QQMINIPROGRAM_CLIENT === clientName) {
                checkApiSupport$1.qqminiprogramCheckApiSupport();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.wpsIosCheckApiSupport();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.wpsAnCheckApiSupport();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WOA_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_IPAD_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.woaIosCheckApiSupport();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WOA_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                checkApiSupport$1.woaAnCheckApiSupport();
                return true;
            }
            cb(false);
        });
    };
    // 通过randcode添加账号
    ClientConnect.prototype.addAccountByRandcode = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var clientName, other, addAccountByRandcode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = params.clientName, other = __rest(params, ["clientName"]);
                        window.logic && window.logic.report('multi_account', "addAccountByRandcode\uFF0C clientName\uFF1A".concat(clientName));
                        return [4 /*yield*/, this.checkClientAPISupport(clientName, 'addAccountByRandcode')];
                    case 1:
                        if (!(_a.sent())) {
                            reject(notSupport);
                            return [2 /*return*/];
                        }
                        addAccountByRandcode = new AddAccount(__assign(__assign({}, other), { onSuccess: resolve, onFail: reject }));
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            addAccountByRandcode.wpsAddAccountByRandcode();
                            return [2 /*return*/, true];
                        }
                        console.log("apiName: addAccountByRandcode ".concat(notSupport), params);
                        reject(notSupport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // 切换登录账号接口
    ClientConnect.prototype.addAccount = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var clientName, other, isSupport, addAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = params.clientName, other = __rest(params, ["clientName"]);
                        return [4 /*yield*/, this.checkClientAPISupport(clientName, 'addAccount')];
                    case 1:
                        isSupport = _a.sent();
                        window.logic && window.logic.report('multi_account', "addAccount isSupport ".concat(isSupport, "\uFF0C clientName\uFF1A").concat(clientName));
                        if (!isSupport) {
                            reject(notSupport);
                            return [2 /*return*/];
                        }
                        addAccount = new AddAccount$1(__assign(__assign({}, other), { onSuccess: resolve, onFail: reject }));
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.wpsAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.docsAddAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
                            addAccount.docsIosAddAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
                            addAccount.docsAnAddAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT === clientName) {
                            addAccount.wxminiprogramAddAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT === clientName) {
                            addAccount.pcWxminiprogramAddAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_QQMINIPROGRAM_CLIENT === clientName) {
                            addAccount.qqminiprogramAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.wpsIosAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.wpsAnAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WOA_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_IPAD_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.woaIosAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WOA_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.woaAnAddAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WOA_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            addAccount.woaAddAccount();
                            return [2 /*return*/, true];
                        }
                        console.log("apiName: addAccount ".concat(notSupport), params);
                        reject(notSupport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // 切换账号接口
    ClientConnect.prototype.switchAccount = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var clientName, other, isSupport, switcAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = params.clientName, other = __rest(params, ["clientName"]);
                        return [4 /*yield*/, this.checkClientAPISupport(clientName, 'switchAccount')];
                    case 1:
                        isSupport = !(_a.sent());
                        window.logic && window.logic.report('multi_account', "switchAccount isSupport ".concat(isSupport, "\uFF0C clientName\uFF1A").concat(clientName));
                        if (isSupport) {
                            reject(notSupport);
                            return [2 /*return*/];
                        }
                        switcAccount = new Switchccount(__assign(__assign({}, other), { onSuccess: resolve, onFail: reject }));
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            switcAccount.wpsSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
                            switcAccount.docsSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
                            switcAccount.docsIosSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
                            switcAccount.docsAnSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT === clientName) {
                            switcAccount.wxminiprogramSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT === clientName) {
                            switcAccount.pcWxminiprogramSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_QQMINIPROGRAM_CLIENT === clientName) {
                            switcAccount.qqminiprogramSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                            switcAccount.wpsIosSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                            switcAccount.wpsAnSwitchAccount();
                            return [2 /*return*/, true];
                        }
                        console.log("apiName: switchAccount ".concat(notSupport), params);
                        reject(notSupport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // 获取端凭证组列表，也就是已登录账号列表。备注：目前只有WPS客户端存在缓存凭证组，web端业务侧自行获取
    ClientConnect.prototype.getLoginList = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var clientName, loginList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = params.clientName, __rest(params, ["clientName"]);
                        return [4 /*yield*/, this.checkClientAPISupport(clientName, 'getLoginList')];
                    case 1:
                        if (!(_a.sent())) {
                            reject(notSupport);
                            return [2 /*return*/];
                        }
                        loginList = new LoginList({
                            onSuccess: resolve,
                            onFail: reject,
                        });
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            loginList.wpsGetAccountListInfo();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                            loginList.wpsIosGetAccountListInfo();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                            loginList.wpsAnGetAccountListInfo();
                            return [2 /*return*/, true];
                        }
                        console.log("apiName: getLoginList ".concat(notSupport), params);
                        reject(notSupport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // 打开登录页接口
    ClientConnect.prototype.openLogin = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var clientName, other, openLogin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = params.clientName, other = __rest(params, ["clientName"]);
                        return [4 /*yield*/, this.checkClientAPISupport(clientName, 'openLogin')];
                    case 1:
                        if (!(_a.sent())) {
                            reject(notSupport);
                            return [2 /*return*/];
                        }
                        openLogin = new OpenLogin$1(__assign(__assign({}, other), { onSuccess: resolve, onFail: reject }));
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                            openLogin.wpsOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
                            openLogin.docsOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
                            openLogin.docsIosOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
                            openLogin.docsAnOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT === clientName) {
                            openLogin.docsIpadOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT === clientName) {
                            openLogin.docsAnPadOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT === clientName) {
                            openLogin.wxminiprogramOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if (index_cjs.CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT === clientName) {
                            openLogin.pcWxminiprogramOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                            openLogin.wpsIosOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                            openLogin.wpsAnOpenLoginDialog();
                            return [2 /*return*/, true];
                        }
                        console.log("apiName: openLogin ".concat(notSupport), params);
                        reject(notSupport);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // 进入企业
    ClientConnect.prototype.toEnterprise = function (params) {
        var clientName = params.clientName, other = __rest(params, ["clientName"]);
        var toEnterprise = new OpenLogin(other);
        window.logic && window.logic.report('multi_account', "toEnterprise\uFF0C clientName\uFF1A".concat(clientName));
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
            toEnterprise.docsIosToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
            toEnterprise.docsAnToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT === clientName) {
            toEnterprise.docsIpadToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT === clientName) {
            toEnterprise.docsAnPadToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_WXMINIPROGRAM_CLIENT === clientName) {
            toEnterprise.wxminiprogramToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_PC_WXMINIPROGRAM_CLIENT === clientName) {
            toEnterprise.pcWxminiprogramToEnterprise();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_QQMINIPROGRAM_CLIENT === clientName) {
            toEnterprise.qqminiprogramToEnterprise();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
            toEnterprise.docsToEnterprise();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
            toEnterprise.wpsToEnterprise();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
            toEnterprise.wpsIosToEnterprise();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
            toEnterprise.wpsAnToEnterprise();
            return true;
        }
        console.log("apiName: toEnterprise ".concat(notSupport), params);
        throw notSupport;
    };
    // 升级客户端
    ClientConnect.prototype.openAppUpgrade = function (params) {
        var clientName = params.clientName;
        var openAppUpgrade = new OpenAppUpgrade();
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
            openAppUpgrade.docsIosOpenAppUpgrade();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
            openAppUpgrade.docsAnOpenAppUpgrade();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT === clientName) {
            openAppUpgrade.docsIpadOpenAppUpgrade();
            return true;
        }
        if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT === clientName) {
            openAppUpgrade.docsAnPadOpenAppUpgrade();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
            openAppUpgrade.wpsOpenAppUpgrade();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
            openAppUpgrade.docsOpenAppUpgrade();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
            openAppUpgrade.wpsIosOpenAppUpgrade();
            return true;
        }
        if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
            openAppUpgrade.wpsAnOpenAppUpgrade();
            return true;
        }
        console.log("apiName: openAppUpgrade ".concat(notSupport), params);
        throw notSupport;
    };
    ClientConnect.prototype.getAppVersion = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, other = __rest(params, ["clientName"]);
            var appVersion$1 = new appVersion(__assign(__assign({}, other), { onSuccess: resolve, onFail: reject }));
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.wpsGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_DOCS_KDESKTOP_MAC_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.docsGetAppVersion();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_IOS_CLIENT === clientName) {
                appVersion$1.docsIosGetAppVersion();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_IPAD_CLIENT === clientName) {
                appVersion$1.docsIpadGetAppVersion();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_CLIENT === clientName) {
                appVersion$1.docsAnGetAppVersion();
                return true;
            }
            if (index_cjs.CLIENT_FLAGS.IS_DOCS_AN_PAD_CLIENT === clientName) {
                appVersion$1.docsAnPadGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_IPAD_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.wpsIosGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.wpsAnGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WOA_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.woaGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WOA_IOS_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_IPAD_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.woaIosGetAppVersion();
                return true;
            }
            if ([index_cjs.CLIENT_FLAGS.IS_WOA_AN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WOA_AN_PAD_CLIENT].indexOf(clientName) >= 0) {
                appVersion$1.woaAnGetAppVersion();
                return true;
            }
            console.log("apiName: getAppVersion ".concat(notSupport), params);
            reject(notSupport);
        });
    };
    ClientConnect.prototype.getCurrentSource = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName;
            var getCurrentSource = new currentSource({
                onSuccess: resolve,
                onFail: reject
            });
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                getCurrentSource.wpsGetCurrentSource();
                return true;
            }
            console.log("apiName: getCurrentSource ".concat(notSupport), params);
            reject(notSupport);
        });
    };
    ClientConnect.prototype.onAccountChange = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, other = __rest(params, ["clientName"]);
            var appVersion = new OnAccountChange(__assign({}, other));
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion.wpsOnAccountChange();
                return true;
            }
            console.log("apiName: getAppVersion ".concat(notSupport), params);
            reject(notSupport);
        });
    };
    // 打开新标签
    ClientConnect.prototype.openNewTab = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var tabIns, clientName;
            return __generator(this, function (_a) {
                tabIns = new OpenNewTab(params);
                clientName = this.getCurrentClient;
                if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                    tabIns.wpsOpenNewTab();
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, notSupport];
            });
        });
    };
    // 监听方法
    ClientConnect.prototype.addListener = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, data = params.data;
            var appVersion = new AddListener(data);
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion.wpsAddListener();
                resolve(true);
            }
            else {
                console.log("apiName: addListener ".concat(notSupport), params);
                reject(notSupport);
            }
        });
    };
    // 移除监听方法
    ClientConnect.prototype.removeListener = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, data = params.data;
            var appVersion = new RemoveListener(data);
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion.wpsRemoveListener();
                resolve(true);
            }
            else {
                console.log("apiName: removeListener ".concat(notSupport), params);
                reject(notSupport);
            }
        });
    };
    // login
    ClientConnect.prototype.login = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, handler = params.handler;
            var appVersion = new Login$1({ handler: handler });
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion.wpsLogin();
                resolve(true);
            }
            else {
                console.log("apiName: login ".concat(notSupport), params);
                reject(notSupport);
            }
        });
    };
    // 调用客户端常用方法
    ClientConnect.prototype.callCommonApi = function (params) {
        return new Promise(function (resolve, reject) {
            var clientName = params.clientName, eventName = params.eventName, data = params.data;
            var appVersion = new Login({
                eventName: eventName,
                data: data
            });
            if ([index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_LINUX_CLIENT].indexOf(clientName) >= 0) {
                appVersion.wpsCallCommonApi();
                resolve(true);
            }
            else {
                console.log("apiName: ".concat(eventName, " ").concat(notSupport), params);
                reject(notSupport);
            }
        });
    };
    return ClientConnect;
}());
/**
 * 通过Proxy包裹, 执行方法前, 先按需设置document.domain
 * 解决在wps客户端内iframe跨域的问题
*/
var index = new Proxy(new ClientConnect(), {
    get: function (target, propKey) {
        var _a;
        var isFrame = window.self !== window.top; // 是否在iframe里面
        var allowClient = [index_cjs.CLIENT_FLAGS.IS_WPS_WIN_CLIENT, index_cjs.CLIENT_FLAGS.IS_WPS_MAC_CLIENT]; // 目前支持的客户端[windows, mac]
        if (isFrame && allowClient.indexOf(index_cjs.getCurrentClient()) > -1) {
            var support_1 = ['wps.cn', 'kdocs.cn']; // 目前支持的domain参数
            var res = (_a = location.search.match(/(\?|&)domain=([^&]*)/g)) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.replace(/(\?|&)domain=/, ''); });
            var domain = res === null || res === void 0 ? void 0 : res.find(function (item) { return support_1.indexOf(item) >= 0; });
            if (domain) {
                document.domain = domain;
            }
        }
        return target[propKey];
    }
});

var CLIENT_FLAGS$1 = index_cjs.CLIENT_FLAGS;
export { CLIENT_FLAGS$1 as CLIENT_FLAG, index as default, notSupport };
